import React from "react";
import MenuItems from './MenuItems';
import RoundedButton from '../elements/form/button/RoundedButton';
import PropTypes from 'prop-types';
import MenuItem from './MenuItem';

export default class MenuMobile extends React.PureComponent {
    logout = () => {
        let { logout } = this.props;

        logout();
    };
    renderLoginButton = () => {
        let { onMenuItemClick } = this.props;

        return (
            <div className={'login-buttons'}>
                <MenuItem className={'login'} link={'/login'} onClick={onMenuItemClick}>Login</MenuItem>
                <MenuItem className={'signup'} link={'/signup'} onClick={onMenuItemClick}>Signup</MenuItem>
            </div>
        )
    };
    render() {
        let { isVisible, onMenuItemClick, isLogged } = this.props;
        let className = isVisible ? 'shown' : 'hidden';

        return (
            <div className={'menu-mobile ' + className}>
                <MenuItems isLogged={isLogged} onClick={onMenuItemClick}/>
                {isLogged ? <RoundedButton className={'logout'} onClick={this.logout}>Logout</RoundedButton> : this.renderLoginButton()}
            </div>
        );
    }
}

MenuMobile.propTypes = {
    isVisible: PropTypes.bool.isRequired,
    isLogged: PropTypes.bool.isRequired,
    onMenuItemClick: PropTypes.func.isRequired,
    logout: PropTypes.func.isRequired,
    isSignUpAvailable: PropTypes.bool.isRequired,
};
